// src/quillUtils.js

import { Quill } from 'react-quill';

// Quill.import is how you safely access Quill's internal modules and Parchment.
//var Parchment = Quill.import('parchment');

/**
 * Registers a custom font size format for Quill.
 * Each call registers a new, uniquely named format.
 * @param {string} formatName - The unique name for this font size format (e.g., 'myFontSize_editor1').
 * @param {string[]} whitelist - An array of font size values (e.g., ['10px', '12px', '14px']).
 * @param {number} [scope=Parchment.Scope.INLINE] - The scope for the attributor.
 */
export function registerCustomFontSize(tenant_id) {

if(tenant_id == 3){
// Add sizes to whitelist and register them
//const Size = Quill.import("formats/size");
const Size = Quill.import('attributors/style/size'); // Import the default size attributor
Size.whitelist = ['1px', '2px', '3px', '4px', '5px', '6px', '7px', '8px', '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px']; //, '24px', '30px', '36px', '48px', '60px', '72px']; // Define your custom font sizes
// //Size.whitelist = ["extra-small", "small", "medium", "large"];
Quill.register(Size, true);
console.log('Quill Size attributor registered for tenant#3!'); // Add this line
}
else {
const Size = Quill.import("formats/size"); 
Size.whitelist = ["extra-small", "small", "medium", "large"];
Quill.register(Size, true);
console.log('Quill Size attributor registered for tenants#1 or #2!'); // Add this line
}

}